<!--
/*******************************************************************************
*@ 컴포넌트명   : indManagePayees.vue
*@ 컴포넌트설명 : 인도 타행 자주쓰는계좌등록
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section>
    <div class="scroll">
      <article class="contents">
        <div class="form">
          <div class="form-row">
            <div class="item-tit">
              {{ /*은행명*/ $t("MPRS-02-02-09-02") }}
              <required />
            </div>
            <div class="item-desc">
              <div class="form-text-field search">
                <div class="input-text-field">
                  <input
                    type="text"
                    id="textfield"
                    class="form-control"
                    v-model="lcalBnkAcnoInfo.bnkEngName"
                    placeholder
                    disabled
                  />
                  <button
                    class="btn sm inline search"
                    @click="openPopup"
                  >{{ /*조회*/ $t("MINQ-02-03-01-14") }}</button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <input-text
              ref="inquryAcno"
              id="inquryAcno"
              :value.sync="inquryAcnoData"
              labelI18n="MPRS-02-02-09-04"
              placeholder="MPRS-02-02-09-04"
              required
              engCase2
              :maxByte="20"
            />
            <div class="info info-etc" v-html="$t('MPRS-02-02-09-12', { 1: $config.CNCYCD_INR })"></div>
          </div>
          <div class="form-row">
            <input-text
              ref="inquryDpstrName"
              id="inquryDpstrName"
              :value.sync="inquryDpstrNameData"
              labelI18n="MPRS-02-02-19-05"
              placeholder="MPRS-02-02-09-06"
              required
              localeCase3
              :maxByte="70"
            />
          </div>
          <div class="form-row" v-if="usePage == 'manage'">
            <input-text
              ref="inquryAcnAls"
              id="inquryAcnAls"
              :value.sync="inquryAcnAls"
              labelI18n="MPRS-02-02-19-07"
              placeholder="MPRS-02-02-19-08"
              required
              :maxByte="40"
              engCase6
            />
          </div>
        </div>
        <div class="btn-area--full fixed">
          <button class="btn md gray" @click="goToPrev()">{{ /*뒤로*/ $t("MPRS-02-02-15-12") }}</button>
          <button
            class="btn md normal"
            @click="goToNext"
            :class="$v.$invalid?'disabled':''"
          >{{ /*다음*/ $t("MPRS-02-02-15-13") }}</button>
        </div>
      </article>
    </div>
    <popup
      :opened.sync="popupOpened"
      :use-footer="false"
      :all-scroll="true"
      title="MPRS-02-02-17-01"
    >
      <template #content>
        <article class="contents transfer bank search">
          <!-- 검색조건 -->
          <div class="form-search top">
            <div class="form-row">
              <div class="item-tit">
                {{fillter? '검색구분' : `IFSC코드 : ${ifscCodeSearch.value}`}}
                <i
                  class="icon icon-fillter"
                  @click="fillter = !fillter"
                />
              </div>
              <div class="item-desc" v-if="fillter">
                <!-- form-check-group -->
                <div class="form-check-group --type1">
                  <template v-for="(data, i) in ifscCodeSearch.radioList">
                    <div class="form-check" :key="i">
                      <input
                        type="radio"
                        :id="`choicetype${i}`"
                        name="choicetype"
                        class="form-check-input"
                        checked="checked"
                        :value="data.value"
                        v-model="ifscCodeSearch.type"
                      />
                      <label :for="`choicetype${i}`" class="form-check-label">{{$t(data.text)}}</label>
                    </div>
                  </template>
                </div>
                <!--// form-check-group end  -->
                <div class="form-text-field">
                  <div class="input-text-field">
                    <input-text
                      id="textfield1"
                      :placeholder="$t('MPRS-02-02-17-06')"
                      :value.sync="ifscCodeSearch.value"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row" v-if="fillter">
              <button
                class="btn lg normal"
                @click="RBF0408W40Call"
              >{{ /*조회*/ $t("MPRS-02-02-13-06") }}</button>
            </div>
          </div>
          <!--// 검색조건 end -->
          <common-grid2
            ref="commonGrid2"
            :list="ifscCodeList.grid"
            :totalCss="['total-count', 'no-border', 'mtop-20']"
            :scroll-event="true"
            :tagType="'div'"
            v-show="showGrid"
            @reSearch="scrollEvent"
          >
            <template v-slot:list="data">
              <div class="box-white -type4">
                <div class="header" @click="popupClose(data.row)">
                  <div class="title">
                    {{ data.row.lcalBnkBrnNo }}
                    <i class="icon icon-arrow-m-right" />
                  </div>
                  <div class="sub-txt">{{data.row.bnkEngName}}</div>
                </div>
                <div class="content">
                  <div class="item">
                    <span class="tit">{{ /*지점*/ $t("MPRS-02-02-18-03") }} :</span>
                    <span class="txt">{{ data.row.lcalBnkBrnEngName }}</span>
                  </div>
                  <div class="item addr">
                    <span class="tit">{{ /*주소*/ $t("MPRS-02-02-14-03") }} :</span>
                    <span class="txt">{{ data.row.lcalBnkAddrCtnt1 }}</span>
                  </div>
                </div>
              </div>
            </template>
          </common-grid2>
        </article>
      </template>
    </popup>
    <modal-pop :opened.sync="modalOpened" class="modal">
      <template #content>{{/*조회 시 최소 4자 이상 입력*/$t("MPRS-02-02-17-10")}}</template>
    </modal-pop>
    <action-sheet
      :opened.sync="actionSheetOpened"
      :actionHeader="true"
      :actionFooter="true"
      :useTopBorder="true"
      title="MPRS-02-02-11-01"
      class="action-sheet"
    >
      <template #content>
        <div class="form-confirm">
          <div class="form-row">
            <div class="item-tit">{{ /*입금계좌번호*/ $t("MPAY-02-01-26-08") }}</div>
            <div class="item-desc">
              <div class="form-text-field">{{ inquryAcno }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="item-tit">{{ /*은행명*/ $t("MPRS-02-02-02-05") }}</div>
            <div class="item-desc">
              <div class="form-text-field">{{ lcalBnkAcnoInfo.bnkEngName }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="item-tit">{{ /*지점명*/ $t("MPRS-02-02-02-06") }}</div>
            <div class="item-desc">
              <div class="form-text-field">{{ lcalBnkAcnoInfo.lcalBnkBrnEngName }}</div>
            </div>
          </div>
        </div>
        <strong class="info-question">{{ /*입력하신 계좌와 지점명이 맞습니까?*/ $t("MPRS-02-02-11-05") }}</strong>
      </template>
      <template #footer>
        <button
          class="btn bottom negative"
          @click="actionSheetOpened=false"
        >{{ /*아니오*/ $t("MPRS-02-02-11-06") }}</button>
        <button class="btn bottom positive" @click="confirm">{{ /*예*/ $t("MPRS-02-02-11-07") }}</button>
      </template>
    </action-sheet>
  </section>
</template>
<script>
import Required from "@/components/template/Required";
import CommonGrid2 from "@/components/page/common/CommonGrid2";
export default {
  components: {
    CommonGrid2,
    Required,
  },
  props: {
    usePage: {
      type: String,
    },
  },
  data() {
    return {
      popupOpened: false,
      modalOpened: false,
      actionSheetOpened: false,

      ovsesSendBnkNo: "", //IFSC코드
      bnkEngName: "", //은행명
      ifscCodeList: [], //IFSC Code 리스트
      sheetLcalBnkBrnEngName: "", //지점명
      page: 1,
      inquryAcno: "", //계좌번호
      inquryDpstrName: "", //예금주명
      prgsYN: false,
      showGrid: true, //grid open
      fillter: true,
      searchType: "searchBox",
      ifscCodeSearch: {
        radioList: [
          { value: "00", text: "MPRS-02-02-17-02" }, //IFSC코드
          { value: "01", text: "MPRS-02-02-17-03" }, //은행명
          { value: "02", text: "MPRS-02-02-17-04" }, //지점명
          // { value: "03", text: "MPRS-02-02-17-05" }, //주소
        ],
        type: "00", //검색조건 항목
        value: "",
      },
      lcalBnkAcnoInfo: {}, //선택한 IFSC코드
      inquryAcnAls: "", //계좌별명
    };
  },
  validations() {
    let customValidations = {
      prgsYN: function () {
        let res = false;
        if (this.usePage == "manage") {
          res =
            !_.isEmpty(this.lcalBnkAcnoInfo.lcalBnkBrnNo) &&
            !_.isEmpty(this.lcalBnkAcnoInfo.bnkEngName) &&
            !_.isEmpty(this.inquryAcno) &&
            !_.isEmpty(this.inquryDpstrName) &&
            !_.isEmpty(this.inquryAcnAls);
        } else {
          res = !_.isEmpty(this.lcalBnkAcnoInfo.lcalBnkBrnNo) && !_.isEmpty(this.lcalBnkAcnoInfo.bnkEngName) && !_.isEmpty(this.inquryAcno) && !_.isEmpty(this.inquryDpstrName);
        }

        return res;
      },
    };
    return customValidations;
  },
  computed: {
    inquryAcnoData: {
      get() {
        return this.inquryAcno;
      },
      set(value) {
        this.inquryAcno = value;
        this.$EventBus.$emit("indRegister", this.$v.$invalid);
      },
    },
    inquryDpstrNameData: {
      get() {
        return this.inquryDpstrName;
      },
      set(value) {
        this.inquryDpstrName = value;
        this.$EventBus.$emit("indRegister", this.$v.$invalid);
      },
    },
  },
  methods: {
    openPopup() {
      this.page = 1;
      this.searchType = "searchBox";
      this.popupOpened = true;
      this.fillter = true;
      this.$set(this.ifscCodeSearch, "type", "00");
      this.$set(this.ifscCodeSearch, "value", "");
    },
    RBF0408W40Call() {
      // if (this.ovsesSendBnkNo.length < 4) {
      //   this.modalOpened = true;
      // } else {
      this.fillter = false;
      this.$post(
        "/customer/acn/MnrcyAcnIFSCSearchPop",
        {
          dmndPageNo: this.page, //요청페이지번호(입력부)
          tranDstCd: "BNKNO",
          pageLineCnt: "10", //페이지라인수(입력부)
          ovsesSendBnkNo: this.ifscCodeSearch.type == "00" ? this.ifscCodeSearch.value : this.ovsesSendBnkNo, //IFSC코드
          bnkEngName: this.ifscCodeSearch.type == "01" ? this.ifscCodeSearch.value : "", //은행명
          lcalBnkBrnEngName: this.ifscCodeSearch.type == "02" ? this.ifscCodeSearch.value : "", //지점명
        },
        this.RBF0408W40Suc,
      );
      // }
    },
    RBF0408W40Suc(res) {
      this.ifscCodeList = res.outItem;
      this.$refs.commonGrid2.changeList(res.outItem.grid, res.outItem.totalLineCnt, this.searchType);
    },
    scrollEvent() {
      if (this.ifscCodeList.gridRowCnt < 10 && this.ifscCodeList.totalLineCnt != 0) {
        return;
      } else if (this.page * this.ifscCodeList.gridRowCnt == this.ifscCodeList.totalLineCnt) {
        return;
      } else {
        this.page++;
        this.searchType = "scroll";
        this.RBF0408W40Call();
      }
    },
    //IFSC코드 선택
    popupClose(data) {
      if (data != null) {
        this.lcalBnkAcnoInfo = {
          ovsesSendBnkNo: data.ovsesSendBnkNo,
          ovsesSendBnkRefno: data.ovsesSendBnkRefno,
          bnkShtenName: data.bnkShtenName,
          bnkEngName: data.bnkEngName,
          lcalBnkBrnNo: data.ovsesSendBnkNo,
          lcalBnkBrnEngName: data.lcalBnkBrnEngName,
          inquryAcno: this.inquryAcno,
        };
        this.sheetLcalBnkBrnEngName = data.lcalBnkBrnEngName;
        this.lcalBnkBrnEngName = data.lcalBnkBrnEngName;
      }
      this.popupOpened = false;
      this.$EventBus.$emit("indRegister", this.$v.$invalid);
    },
    setInfo() {
      this.mnrcvInfo = {
        mnrcvAcnAls: "",
        mnrcvAcno: this.inquryAcnoData, //계좌번호
        mnrcvCncycd: this.$config.CNCYCD_INR, //통화코드
        mnrcvDpstrName: this.inquryDpstrNameData, //예금주명
        mnrcvOthrBnkName: this.lcalBnkAcnoInfo.bnkEngName, //은행명
        mnrcvSerno: "",
        rcevnBnkIfscCode: this.lcalBnkAcnoInfo.lcalBnkBrnNo, //IFSC코드
        mnrcvBrnName: this.lcalBnkAcnoInfo.lcalBnkBrnEngName, //지점명
      };
      return this.mnrcvInfo;
    },
    valid() {
      return !this.$v.$invalid;
    },
    goToPrev() {
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    goToNext() {
      if (this.usePage == "manage") {
        this.$refs.inquryAcnAls.$v.$touch();
        if (this.$refs.inquryAcnAls.$v.$invalid) return;
      }

      this.actionSheetOpened = true;
    },
    confirm() {
      // if (this.showLcalBnkBrnEngName == false) {
      //   this.lcalBnkAcnoInfo = {
      //     ovsesSendBnkNo: this.popupRBF0408W40.response.grid[0].ovsesSendBnkNo,
      //     ovsesSendBnkRefno: this.popupRBF0408W40.response.grid[0].ovsesSendBnkRefno,
      //     bnkShtenName: this.popupRBF0408W40.response.grid[0].bnkShtenName,
      //     bnkEngName: this.popupRBF0408W40.response.grid[0].bnkEngName,
      //     lcalBnkBrnNo: this.popupRBF0408W40.response.grid[0].lcalBnkBrnNo,
      //     lcalBnkBrnEngName: this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName,
      //     inquryAcno: this.inquryAcno,
      //   };
      //   this.lcalBnkBrnEngName = this.popupRBF0408W40.response.grid[0].lcalBnkBrnEngName;
      // }
      this.$post(
        "/customer/acn/MnrcyAcnRegiRes",
        {
          dmndPageNo: "00000",
          pageLineCnt: "00000",
          gridRowCnt: "00001",
          inquiryUserStupAcnDstcd1: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
          deviceType: "mobile",
          inDataGrid: [
            {
              inquryUserStupAcnDstcd2: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
              inquryAcno: this.inquryAcno, // 계좌번호
              inqurySerno: "1", // 일련번호
              inquryBrncoEcrypPwd: "", // 계좌비밀번호
              inquryAcnAls: this.inquryAcnAls, // 계좌별명
              inquryDpstrName: this.inquryDpstrName, // 예금주명
              inquryOthrBnkName: this.lcalBnkAcnoInfo.bnkEngName, // 타은행명
              inquryBrnName: this.lcalBnkAcnoInfo.lcalBnkBrnEngName, // 부점명
              inquryCncycd: this.$config.CNCYCD_INR, //통화코드
              inquryPrcssDstcd: "2", // 처리구분코드 1:출금계좌등록, 2:입금계좌등록, 5:계좌번호변경, 6:계좌번호해지
              inquryObaobDstcd: "2", // 당타행구분코드 1:당행, 2:타행
              draweAcitmDstcd: "01",
              rcevnBnkIfscCode: this.lcalBnkAcnoInfo.lcalBnkBrnNo,
            },
          ],
        }, //input값 요청할데이터
        this.RBF0600C60Suc, //호출 성공시 실행하는 콜백
      );
      this.actionSheetOpened = false;
    },
    /* API_RBF0600C60 호출 성공 */
    RBF0600C60Suc() {
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
  },
};
</script>